module.exports = __webpack_public_path__ + "img/10551381_L.9271bcb9.png";